import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import ShopLayout, { fmtPrice } from '../../shop/ShopLayout';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const COUNTRIES = ['España', 'Alemania', 'Reino Unido', 'Francia', 'Países Bajos', 'Suiza', 'Austria', 'Bélgica', 'Italia', 'Portugal', 'Dinamarca', 'Suecia', 'Noruega', 'Irlanda', 'Estados Unidos', 'Otro'];

function ReserveModal({ bike, onClose, onDone }) {
  const [form, setForm] = useState({ name: '', surname: '', document_id: '', address: '', country: '', email: '', phone: '', message: '' });
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [countries, setCountries] = useState(null);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  useEffect(() => {
    axios.get(`${API}/shop/public/shipping-countries`).then((r) => {
      const list = r.data.length ? r.data : COUNTRIES.map((c) => ({ id: c, name: c, price: 0 }));
      setCountries(list);
      setForm((f) => ({ ...f, country: list.find((c) => c.name === 'España')?.name || list[0]?.name || '' }));
    }).catch(() => setCountries(COUNTRIES.map((c) => ({ id: c, name: c, price: 0 }))));
  }, []);

  const shipping = countries?.find((c) => c.name === form.country)?.price || 0;
  const total = (bike.price || 0) + shipping;

  const submit = async (e) => {
    e.preventDefault();
    setSending(true); setError('');
    try {
      const r = await axios.post(`${API}/shop/public/reservations`, { bicycle_id: bike.id, ...form });
      onDone(r.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'No se pudo enviar la reserva. Inténtalo de nuevo.');
    } finally { setSending(false); }
  };

  const two = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 };
  return (
    <div className="ws-modal-bg" onClick={onClose} data-testid="reserve-modal">
      <div className="ws-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 600, maxHeight: '92vh', overflowY: 'auto' }}>
        <button className="ws-modal-close" onClick={onClose} aria-label="Cerrar" data-testid="reserve-close">×</button>
        <p className="ws-pretitle">Reservar bicicleta</p>
        <h3 className="ws-title ws-title--dark" style={{ fontSize: 30, marginBottom: 6 }}>{bike.model}</h3>
        <p className="ws-muted" style={{ fontSize: 13, marginBottom: 24 }}>Talla {bike.size} · Ref. {bike.reference} · <span style={{ color: '#FE9A25' }}>{fmtPrice(bike.price)}</span> IVA incl.</p>
        <form onSubmit={submit} style={{ display: 'grid', gap: 14 }}>
          <div style={two}>
            <input className="ws-input" placeholder="Nombre *" required value={form.name} onChange={set('name')} data-testid="reserve-name" />
            <input className="ws-input" placeholder="Apellidos *" required value={form.surname} onChange={set('surname')} data-testid="reserve-surname" />
          </div>
          <input className="ws-input" placeholder="DNI / Pasaporte *" required value={form.document_id} onChange={set('document_id')} data-testid="reserve-document" />
          <input className="ws-input" placeholder="Dirección completa *" required value={form.address} onChange={set('address')} data-testid="reserve-address" />
          <div style={two}>
            <select className="ws-input" required value={form.country} onChange={set('country')} data-testid="reserve-country">
              {(countries || []).map((c) => <option key={c.id} value={c.name}>{c.name}{c.price > 0 ? ` · envío ${fmtPrice(c.price)}` : ' · envío gratis'}</option>)}
            </select>
            <input className="ws-input" placeholder="Teléfono *" required value={form.phone} onChange={set('phone')} data-testid="reserve-phone" />
          </div>
          <input className="ws-input" type="email" placeholder="Email *" required value={form.email} onChange={set('email')} data-testid="reserve-email" />
          <textarea className="ws-textarea" rows={2} placeholder="Mensaje (opcional)" value={form.message} onChange={set('message')} data-testid="reserve-message" />
          <div style={{ background: '#fff', border: '1px solid #EDE8E1', borderRadius: 6, padding: '14px 18px' }} data-testid="reserve-summary">
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, padding: '4px 0' }}><span>Bicicleta</span><span data-testid="summary-bike">{fmtPrice(bike.price)}</span></div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, padding: '4px 0', borderBottom: '1px solid #EDE8E1' }}><span>Envío{form.country ? ` · ${form.country}` : ''}</span><span data-testid="summary-shipping">{shipping > 0 ? fmtPrice(shipping) : 'Gratis'}</span></div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '10px 0 0' }}><span style={{ fontSize: 12, letterSpacing: 2, textTransform: 'uppercase' }}>Total a transferir</span><span className="ws-price" style={{ fontSize: 24 }} data-testid="summary-total">{fmtPrice(total)}</span></div>
          </div>
          {error && <p style={{ color: '#c0392b', fontSize: 13, margin: 0 }} data-testid="reserve-error">{error}</p>}
          <button type="submit" className="ws-btn ws-btn--lg" disabled={sending} style={{ justifyContent: 'center' }} data-testid="reserve-submit">
            {sending ? 'Enviando…' : 'Confirmar reserva'} <span className="ws-arrow" />
          </button>
          <p className="ws-muted" style={{ fontSize: 12, margin: 0 }}>Al confirmar, la bicicleta queda reservada a tu nombre y se genera una proforma con los datos bancarios para realizar la transferencia del total (bicicleta + envío). Pago exclusivamente por transferencia bancaria.</p>
        </form>
      </div>
    </div>
  );
}

export default function ShopDetail({ embedded = false }) {
  const { id } = useParams();
  const base = embedded ? '/tienda-interna' : '/tienda';
  const [bike, setBike] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [active, setActive] = useState(0);
  const [reserving, setReserving] = useState(false);
  const [done, setDone] = useState('');

  useEffect(() => {
    axios.get(`${API}/shop/public/bikes/${id}`).then((r) => setBike(r.data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return <ShopLayout embedded={embedded}><div className="ws-empty" data-testid="shop-detail-unavailable">Esta bicicleta ya no está disponible.<br /><Link to={base} className="ws-link" style={{ marginTop: 20 }}>Volver a la tienda <span className="ws-arrow" /></Link></div></ShopLayout>;
  }
  if (!bike) return <ShopLayout embedded={embedded}><div className="ws-empty">Cargando…</div></ShopLayout>;

  const media = [...bike.photos.map((src) => ({ type: 'img', src })), ...(bike.video_url ? [{ type: 'video', src: bike.video_url }] : [])];
  const current = media[active];

  return (
    <ShopLayout embedded={embedded}>
      <Link to={base} className="ws-link" style={{ marginBottom: 28, display: 'inline-flex' }} data-testid="shop-back"><span className="ws-arrow" style={{ transform: 'rotate(180deg)' }} /> Volver a la tienda</Link>
      <div className="ws-detail ws-reveal" data-testid="shop-detail">
        <div>
          <div className="ws-gallery-main" data-testid="shop-gallery">
            {!current ? <div className="ws-noimg" style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Sin foto</div>
              : current.type === 'video' ? <video src={current.src} controls playsInline data-testid="shop-video" />
              : <img src={current.src} alt={bike.model} />}
          </div>
          {media.length > 1 && (
            <div className="ws-thumbs">
              {media.map((m, i) => (
                <button key={i} className={`ws-thumb ${i === active ? 'ws-thumb--active' : ''}`} onClick={() => setActive(i)} data-testid={`shop-thumb-${i}`}>
                  {m.type === 'video' ? <><video src={m.src} muted /><span className="ws-thumb-play">Vídeo</span></> : <img src={m.src} alt="" />}
                </button>
              ))}
            </div>
          )}
        </div>
        <div>
          <p className="ws-pretitle">{bike.is_electric ? 'E-Bike' : 'Bicicleta de carretera'} · Ref. {bike.reference}</p>
          <h1 className="ws-title" style={{ fontSize: 'clamp(34px, 4vw, 54px)' }} data-testid="shop-detail-title">{bike.model}</h1>
          <p className="ws-price" style={{ fontSize: 34, margin: '18px 0 24px' }} data-testid="shop-detail-price">{fmtPrice(bike.price)}</p>
          {bike.description && <p className="ws-text" style={{ marginBottom: 28 }} data-testid="shop-detail-description">{bike.description}</p>}
          <ul className="ws-specs" data-testid="shop-specs">
            <li><span>Modelo</span><span>{bike.model}</span></li>
            <li><span>Talla</span><span>{bike.size}</span></li>
            {bike.year && <li><span>Año</span><span>{bike.year}</span></li>}
            {bike.features.map((f, i) => <li key={i}><span>{f.label}</span><span>{f.value}</span></li>)}
            <li><span>Referencia</span><span>{bike.reference}</span></li>
          </ul>
          <div style={{ marginTop: 32 }}>
            {done ? (
              <div style={{ background: '#fff', border: '1px solid #EDE8E1', borderRadius: 6, padding: 20 }} data-testid="reserve-success">
                <p className="ws-pretitle" style={{ color: '#FE9A25', marginBottom: 6 }}>Reserva confirmada</p>
                <p className="ws-text" style={{ margin: 0 }}>{done.message}</p>
                {done.proforma_number && <p className="ws-muted" style={{ fontSize: 13, marginTop: 10 }}>Proforma <b>{done.proforma_number}</b>{done.total ? ` · Total a transferir ${fmtPrice(done.total)}` : ''}{done.email_sent === false ? ' · Nos pondremos en contacto contigo con los datos de pago.' : ''}</p>}
              </div>
            ) : (
              <button className="ws-btn ws-btn--lg" onClick={() => setReserving(true)} data-testid="reserve-btn">Reservar bicicleta <span className="ws-arrow" /></button>
            )}
          </div>
        </div>
      </div>
      {reserving && <ReserveModal bike={bike} onClose={() => setReserving(false)} onDone={(data) => { setDone(data); setReserving(false); }} />}
    </ShopLayout>
  );
}
